import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { mockTransactions } from "../../data/mockData";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import EmailIcon from "@mui/icons-material/Email";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrafficIcon from "@mui/icons-material/Traffic";
import Header from "../../components/Header";
import LineChart from "../../components/LineChart";
import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
import ProgressCircle from "../../components/ProgressCircle";


const Dashboard = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return ( 
        <Box m='20px'>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Header title='DASHBOARD' subtitle='Welcome to your dashboard'></Header>
                <Box>
                    <Button sx={{backgroundColor: colors.blueAccent[700], color: colors.grey[100], fontSize:'14px', fontWeight:'bold', padding:'10px 20px'}}>
                    <DownloadOutlinedIcon sx={{mr:'10px'}} />
                    Download Reports
                    </Button>
                </Box>
            </Box>
            <Box 
            display='grid'
            gridTemplateColumns='repeat(12, 1fr)'
            gridAutoRows='140px'
            gap='20px'
            >
                <Box gridColumn='span 3' backgroundColor={colors.primary[400]} display='flex' alignItems='center' justifyContent='center'>
                    <StatBox title='12,361' subtitle='Emails Sent' progress='0.75' increase='+14%' icon={<EmailIcon sx={{fontSize:'26px', color: colors.greenAccent[600]}} />}></StatBox>
                </Box>            
                <Box gridColumn='span 3' backgroundColor={colors.primary[400]} display='flex' alignItems='center' justifyContent='center'>
                    <StatBox title='121,121' subtitle='Sold Items' progress='0.75' increase='+22%' icon={<PointOfSaleIcon sx={{fontSize:'26px', color: colors.greenAccent[600]}} />}></StatBox>
                </Box>
                <Box gridColumn='span 3' backgroundColor={colors.primary[400]} display='flex' alignItems='center' justifyContent='center'>
                    <StatBox title='11,101' subtitle='New Clients' progress='0.75' increase='+4%' icon={<PersonAddIcon sx={{fontSize:'26px', color: colors.greenAccent[600]}} />}></StatBox>
                </Box>
                <Box gridColumn='span 3' backgroundColor={colors.primary[400]} display='flex' alignItems='center' justifyContent='center'>
                    <StatBox title='12,361' subtitle='Traffic' progress='0.75' increase='+1%' icon={<TrafficIcon sx={{fontSize:'26px', color: colors.greenAccent[600]}} />}></StatBox>
                </Box>
                <Box gridColumn='span 8' gridRow='span 2'
                backgroundColor={colors.primary[400]}>
                    <Box mt='25px' p='0 30px' display='flex' justifyContent='space-between' alignItems='center'>
                        <Box>
                            <Typography variant='h5' sx={{color: colors.grey[100], fontWeight:'bold'}}>Revenue Generated</Typography>
                            <Typography variant='h3' fontWeight='bold' sx={{color: colors.greenAccent[500]}}>$12,345,678</Typography>
                        </Box>
                        <Box>
                            <IconButton>
                                <DownloadOutlinedIcon sx={{fontSize:'26px' ,color: colors.greenAccent[500]}} />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box height='250px' mt='-20px'>
                        <LineChart isDashboard={true} data={mockTransactions}></LineChart>
                    </Box>
                </Box>
                    <Box gridColumn='span 4' gridRow='span 2' backgroundColor={colors.primary[400]} overflow='auto'>
                        <Box display='flex' justifyContent='space-between' alignItems='center' borderBottom={`4px solid ${colors.primary[500]}`} colors={colors.grey[100]} p='15px'>
                            <Typography variant='h5' sx={{color: colors.grey[100], fontWeight:'bold'}}>Recent Transactions</Typography>
                        </Box>
                        {mockTransactions.map((transaction, index) => (
                            <Box 
                            key={`${transaction.txId}-${index}`}
                            display='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            borderBottom={`4px solid ${colors.primary[500]}`}
                            p='15px'
                            >
                                <Box>
                                    <Typography variant='h5' sx={{color: colors.greenAccent[500], fontWeight:'bold'}}>{transaction.txId}</Typography>
                                    <Typography  sx={{color: colors.grey[100]}}>{transaction.user}</Typography>
                                </Box>
                                <Box color={colors.grey[100]}>
                                    {transaction.date}
                                </Box>
                                <Box backgroundColor={colors.greenAccent[500]} p='5px 10px' borderRadius='4px'>
                                    {transaction.cost}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    <Box gridColumn='span 4' gridRow='span 2' backgroundColor={colors.primary[400]} p='30px'>
                            <Typography variant='h5' fontWeight='600'>
                                Campaigns
                            </Typography>
                            <Box display='flex' flexDirection='column' alignItems='center' mt='25px'>
                                <ProgressCircle size='125' />
                                <Typography variant='h5' color={colors.greenAccent[500]} sx={{ mt: '15px' }}>$345,678 revenue generated</Typography>
                                <Typography>from 12,345 sales</Typography>
                            </Box>
                    </Box>
                    <Box gridColumn='span 4' gridRow='span 2' backgroundColor={colors.primary[400]}>
                            <Typography variant='h5' fontWeight='600' sx={{p:'30px 30px 0 30px'}}>
                                Sales Qty
                            </Typography>
                            <Box height='250px' mt='-20px'>
                                <BarChart isDashboard={true} />
                            </Box>
                    </Box>
                    <Box gridColumn='span 4' gridRow='span 2' backgroundColor={colors.primary[400]}>
                            <Typography variant='h5' fontWeight='600' sx={{p:'30px 30px 0 30px'}}>
                                Geography Traffic
                            </Typography>
                            <Box height='230px' mt='-20px'>
                                <GeographyChart isDashboard={true} />
                            </Box>
                    </Box>
            </Box>
        </Box>
     );
}

export default Dashboard;